module.exports = __webpack_public_path__ + "img/dash-02.7706360d.jpg";